import { Box, useColorMode, useStyleConfig } from "@chakra-ui/react";
function Card(props) {
  const { variant, children, ...rest } = props;
  const styles = useStyleConfig("Card", { variant });
  const { colorMode } = useColorMode();

  return (
    <Box
      bg={colorMode === "dark" ? "navy.800" : "white"}
      __css={styles}
      {...rest}
    >
      {children}
    </Box>
  );
}

export default Card;
